import { Module } from "vuex";
import { StoreState } from "@/store/type";
import state, { IChurningState } from "./state";
import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";

const ChurningModule: Module<IChurningState, StoreState> = {
  state,
  mutations,
  actions,
  getters,
};

export default ChurningModule;
